"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usesEducationalStore = exports.DEFAULT_CUSTOM_STORE = void 0;
exports.DEFAULT_CUSTOM_STORE = {
    template: "studio",
    accent: "blue",
    font: "sans",
    logoAssetId: null,
    faviconAssetId: null,
    hero: {
        heading: "Care that fits your life",
        body: "Explore treatments available through our clinic.",
        imageAssetId: null,
    },
    featuredProductIds: [],
    about: { heading: "About our clinic", body: "" },
    faqs: [],
    sections: ["hero", "featured", "about", "faq"],
};
/** Custom educational stores retain Bloom's category and treatment browsing routes. */
function usesEducationalStore(clinic) {
    return (clinic.storefrontVariant === "educational" ||
        (clinic.storefrontVariant === "custom" &&
            clinic.customDesign?.template === "educational"));
}
exports.usesEducationalStore = usesEducationalStore;
//# sourceMappingURL=customStore.js.map